








import Vue from 'vue';
import { Data as ArticleData } from '@root/modules/article/types/article';
import rootConfig from '@root/config/root.config';
import LinkHandler from '@core/components/helpers/LinkHandler.vue';

interface Props {
  article: ArticleData;
}

interface Computed {
  tagBaseUrl: string;
}

export default Vue.extend<unknown, unknown, Computed, Props>({
  components: {
    LinkHandler,
  },
  props: {
    article: {
      type: Object,
      required: true,
    },
  },
  computed: {
    tagBaseUrl() {
      return rootConfig.tag_base_url;
    },
  },
});
